<template>
  <main class="relative mx-auto w-full max-w-[10rem] min-h-screen overflow-hidden bg-[#191e21] font-['PingFang_SC','Helvetica_Neue',Arial,sans-serif] text-white">
    <div
      class="absolute inset-0 bg-cover bg-top bg-no-repeat"
      :style="{ backgroundImage: `url(${assets.BG})` }"
      aria-hidden="true"
    ></div>

    <div class="relative z-[1] flex min-h-[100svh] flex-col px-[20px] pb-[18px]">
      <div class="pointer-events-none flex justify-center" aria-hidden="true">
        <img :src="assets.TITLE" alt="" class="mt-[100px] h-[39px] w-[226px] object-fill" />
      </div>

      <section class="mt-[209px] flex flex-1 flex-col items-center">
        <h1
          class="m-0 text-center text-[24px] font-medium leading-[1.5] tracking-[0.12em] font-santi"
        >
          查询结果
        </h1>

        <div class="mt-[22px] rounded-[12px] bg-[rgba(254,233,191,0.25)] p-[12px] backdrop-blur-[4px] w-[335px] font-santi">
          <div class="text-[16px] font-medium">尊敬的用户您好：</div>
          <div class="flex-col items-center mt-[13px]">
            <p class="text-[15px] font-medium">您查询的数码为</p>
            <p v-if="productInfo?.Code" class="text-[15px] font-[700] mb-[13px] mt-[6px]">{{ productInfo.Code }}</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="284" height="1" viewBox="0 0 284 1" fill="none">
              <path d="M0 0.5H283.5" stroke="url(#paint0_linear_4160_9564)"/>
              <defs>
                <linearGradient id="paint0_linear_4160_9564" x1="283.5" y1="0.999996" x2="-0.499996" y2="0.999095" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#6D6963" stop-opacity="0"/>
                  <stop offset="0.49416" stop-color="#6D6963"/>
                  <stop offset="1" stop-color="#6D6963" stop-opacity="0"/>
                </linearGradient>
              </defs>
            </svg>
            <p class="text-[15px] font-medium mt-[8px] mb-[4px]">您购买的</p>
            <p v-if="productInfo?.ProductName" class="text-[15px] font-[700]">【{{ productInfo.ProductName }}】</p>
            <p class="text-[15px] font-medium mb-[13px] mt-[15px]">是由三体宇宙授权的正品产品，感谢您的支持!</p>
          </div>
        </div>

        <footer class="mt-[16px] flex justify-center pb-[18px]">
          <img :src="assets.BOTTOM" alt="三体宇宙" class="block h-[26px] w-[147px] object-contain" />
        </footer>
      </section>
    </div>

    <div class="absolute right-[21px] bottom-[18px] z-[1]">
      <img :src="assets.RIGHT_LOGO" alt="三体宇宙" class="block h-[9px] w-[43px] object-contain" />
    </div>
  </main>
</template>

<script>
const BG = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bg.png";
const TITLE = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/title_icon.png";
const BOTTOM = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bottom_icon.png";
const RIGHT_LOGO = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/right_logo.png";

export default {
  data() {
    return {
      assets: { BG, TITLE, BOTTOM, RIGHT_LOGO },
      constants: {
        number: "8281760452641684",
        product_name: "红色的水杯",
        product_desc: "三体阶梯|三体宇宙-咖啡杯400ml产品介绍"
      },
      productInfo: {},
    };
  },
  mounted(){
    let cachedData = this.$route.query.value;
    this.productInfo = JSON.parse(cachedData)
  },
  methods: {
    onXcx(){
      // window.location.href = `weixin://dl/business/?appid=wxab51979a64941d59&path=pages/index/index&env_version=release`;
      window.location.href = `https://mp.weixin.qq.com/s/VnRO7Hb3TvgwUvVZzJhzLQ`
    },
    getProductInfo(){

    },
  }
};
</script>

<style>
@media (min-width: 751px) {
  body {
    background: #0d1012;
  }
}
</style>
